import { cva } from 'class-variance-authority';

// only the transform (rotate) animates — NOT colour. The platform default/hover icon colour is the
// same cream, so a colour transition buys nothing and would animate the dark→cream token correction
// on first paint (a visible dark flash). Same reasoning on iconVariants/labelVariants below.
export const chevronVariants = cva('!size-3 transform flex-shrink-0 transition-transform', {
  variants: {
    active: {
      true: 'ua-side-nav-item-active opacity-0 group-hover/PlatformSideNavNestedItem:opacity-100',
      // Platform chevrons stay hidden until the nested item row itself is hovered.
      false:
        'ua-side-nav-item-active-false opacity-0 group-hover/PlatformSideNavNestedItem:opacity-100',
    },
    open: {
      true: 'rotate-90',
      false: '',
    },
    isSideNavExpanded: {
      true: '',
      false: 'hidden',
    },
  },
});

export const iconVariants = cva('size-[18px]', {
  variants: {
    active: {
      true: 'ua-side-nav-item-active',
      false: 'ua-side-nav-item-active-false',
    },
  },
  defaultVariants: {
    active: false,
  },
});

export const labelVariants = cva('transition-all truncate', {
  variants: {
    active: {
      true: 'ua-side-nav-item-active',
      false: 'ua-side-nav-item-active-false',
    },
    isSideNavExpanded: {
      true: 'opacity-100',
      false: 'opacity-0',
    },
  },
  defaultVariants: {
    active: false,
  },
});

export const rootVariants = cva(
  'justify-between pe-[7px] rounded-md py-[9px] ps-[9px] transition-colors focus-visible:shadow-xs',
  // collapsed keeps the symmetric 9px box; expanded overrides py to 8px below (pe is 7px, tighter
  // than the leading edge because the trailing chevron carries its own optical gap)
  {
    variants: {
      active: {
        true: 'focus-visible:ring-brand',
        false: 'ua-side-nav-item-active-false focus-visible:ring-gray',
      },
      expanded: {
        true: '',
        false: '',
      },
      isSideNavExpanded: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        active: false,
        className: 'group/NavItemLinkDefault',
      },
      {
        isSideNavExpanded: true,
        className: 'py-[8px]',
      },
      {
        active: true,
        expanded: false,
        className: 'ua-side-nav-item-active',
      },
      {
        active: true,
        expanded: true,
        className: 'ua-platform-side-nav-nested-item-active-expanded',
      },
      {
        active: true,
        isSideNavExpanded: false,
        className: 'ua-side-nav-item-active',
      },
    ],
  },
);

export const subItemRootVariants = cva(
  'py-xs !rounded-md px-sm items-center transition-colors focus-visible:shadow-xs',
  {
    variants: {
      active: {
        true: 'focus-visible:ring-brand',
        false: 'ua-side-nav-nested-item-active-false focus-visible:ring-gray',
      },
      expanded: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      { active: true, expanded: false, className: 'ua-side-nav-nested-item-active' },
      {
        active: true,
        expanded: true,
        className: 'ua-platform-side-nav-nested-item-active-expanded',
      },
      { active: false, className: 'group/NestedNavItemLinkDefault' },
    ],
  },
);

export const subItemLabelVariants = cva('', {
  variants: {
    active: {
      true: 'ua-side-nav-nested-item-active',
      false: 'ua-side-nav-nested-item-active-false',
    },
    isSideNavExpanded: {
      true: '',
      false: 'hidden',
    },
  },
});
export const subSubItemLabelVariants = cva('', {
  variants: {
    active: {
      true: 'ua-side-nav-nested2-item-active',
      false: 'ua-side-nav-nested2-item-active-false',
    },
    isSideNavExpanded: {
      true: '',
      false: 'hidden',
    },
  },
});

export const subItemChevronVariants = cva(
  'size-4 opacity-0 group-hover/PlatformSideNavNestedItem:opacity-100',
  {
    variants: {
      expanded: {
        true: 'rotate-90',
        false: '',
      },
      active: {
        true: 'ua-side-nav-nested-item-active',
        false: 'ua-side-nav-nested-item-active-false',
      },
    },
  },
);

export const subSubItemRootVariants = cva('!rounded-sm transition-colors focus-visible:shadow-xs', {
  variants: {
    active: {
      true: 'ua-side-nav-nested2-item-active focus-visible:ring-brand',
      false: 'ua-side-nav-nested2-item-active-false focus-visible:ring-gray',
    },
  },
  compoundVariants: [{ active: false, className: 'group/Nested2NavItemLinkDefault' }],
});
